export default __webpack_public_path__ + "static/media/emerald-mobile.12fb5194.jpg";